import React, { useState } from 'react'

import { Field, Form, Formik } from 'formik'
import { Container } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'

import reviewAxiosClient from './reviewAxiosClient'
import FormErrorMessage from '../common/FormErrorMessage'
import NiceButton from '../common/NiceButton'
import PublicLayout from '../common/PublicLayout'
import { RequiredMark } from '../common/RequiredMark'

function ReviewLoginPage() {
    const [isLoading, setIsLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [passwordShown, setPasswordShown] = useState(false)
    const navigate = useNavigate()
    const { token } = useParams<{ token: string }>()

    const validate = (values: any) => {
        const errors: any = {}

        if (!values.username.trim()) {
            errors.username = 'Povinne pole'
        }

        if (!values.password.trim()) {
            errors.password = 'Povinne pole'
        }

        return errors
    }

    const submit = async (values: any) => {
        setErrorMsg('')
        setIsLoading(true)
        try {
            const response = await reviewAxiosClient.post('review/login', {
                reviewToken: token,
                username: values.username,
                password: values.password,
            })

            if (response.data?.accessToken) {
                localStorage.setItem('reviewAccessToken', response.data.accessToken)
                localStorage.setItem('reviewClientName', response.data.clientName || '')
                navigate(`/review/${token}/posts`, { replace: true })
            }
        } catch (error: any) {
            setErrorMsg('Neplatne prihlasovacie udaje')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <PublicLayout>
            <Container>
                <div className="row d-flex justify-content-center py-5">
                    <div className="col-md-5">
                        <h2 className="text-center mb-5">Schvalovanie prispevkov</h2>

                        <div className="rounded-content-body">
                            <Formik
                                initialValues={{ username: '', password: '' }}
                                validate={validate}
                                onSubmit={submit}
                            >
                                <Form>
                                    <div className="form-group">
                                        <label htmlFor="username">Pouzivatelske meno<RequiredMark/></label>
                                        <Field id="username" name="username" className="form-control" />
                                        <FormErrorMessage name="username" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="password">Heslo<RequiredMark/></label>
                                        <div className="input-group show-psw-input-group">
                                            <Field
                                                id="password"
                                                type={passwordShown ? 'text' : 'password'}
                                                name="password"
                                                className="form-control"
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    onClick={() => setPasswordShown(!passwordShown)}
                                                    className=""
                                                    type="button"
                                                    title={passwordShown ? 'Skryt heslo' : 'Zobrazit heslo'}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                         fill="currentColor" className="bi bi-key"
                                                         viewBox="0 0 16 16">
                                                        <path
                                                            d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8m4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5"/>
                                                        <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <FormErrorMessage name="password" />
                                    </div>

                                    {errorMsg &&
                                        <div className="text-danger form-text text-center pb-2">{errorMsg}</div>}
                                    <NiceButton type="submit" isLoading={isLoading}>
                                        Prihlasit sa
                                    </NiceButton>
                                </Form>
                            </Formik>
                        </div>
                    </div>
                </div>
            </Container>
        </PublicLayout>
    )
}

export default ReviewLoginPage
